import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../IconV1'

export const AccordionItem = styled.li`
  position: relative;
  list-style: none;

  &:hover {
    cursor: pointer;
  }

  ${p =>
    p.iconOnRight &&
    `
    margin-bottom: 1.25rem;
  `}
`

export const Content = styled.div`
  display: block;
  padding-left: 2.5rem;
  border-radius: 0 0 0.15625rem 0.15625rem;
  ${p =>
    p.hasColor &&
    `
    background-color: ${color.ALICE_BLUE};
    color: ${color.LIGHT_CHARCOAL};
    padding: 0 1.25rem 1.25rem 1.25rem;
    font-style: normal;
    font-weight: normal;
    font-size: 1.125rem;
    line-height: 2rem;
  `}
`

export const Label = styled.div`
  margin-top: -1px;
  ${p =>
    !p.noBorder &&
    `
    border-bottom: solid 0.0625rem #aaa;
    margin-left: 2.5rem;
  `}

  padding: 0.75rem 0;
  line-height: 1.5625rem;
  font-size: 1.125rem;
  color: ${p => (p.hasColor ? color.REGAL : '#0E60C9')};
  transition: all 0.2s;

  ${p =>
    p.iconOnRight &&
    `
    padding-left: 1.25rem;
    background-color: ${color.ALICE_BLUE};
  `}

  ${AccordionItem}:not(:first-child) & {
    ${p =>
      !p.noBorder &&
      `
      border-top: solid 1px #aaa;
    `}
  }

  border-radius: 0.15625rem;
  ${p =>
    p.expanded &&
    `
    border-radius: 0.15625rem 0.15625rem 0 0;
  `}
  ${p =>
    p.iconOnRight &&
    `
    background: ${color.ALICE_BLUE};
  `}
  &:hover {
    background: #f1f5f9;
    color: ${p => (p.hasColor ? color.REGAL : '#0E60C9')};
    margin-left: 0;
    padding-left: ${p => (p.iconOnRight ? `1.25rem` : `2.5rem`)};
  }
  display: flex;
  ${p =>
    p.iconOnRight &&
    `
    justify-content: space-between;
    font-weight: bold;
  `}
`

export const Icon = styled(BaseIcon)`
  display: flex;
  top: 0.625rem;
  left: 0.3125rem;
  width: 1.875rem;
  height: 1.875rem;
  line-height: 1.875rem;
  color: #0e60c9;
`
